module.exports = __webpack_public_path__ + "img/Julie.6c60206d.jpeg";